<template>
    <Loader v-if="isFrontOfficePending" class="-full -base"/>
    <template v-else>
        <Header />

        <section class="main landing" data-barba="container" data-barba-namespace="home">
            <div class="picture--house">
                <img :src="splashImage" alt="">
            </div>
            <div class="landing--content">
                <div class="landing--wrapper">
                    <img :src="windowWidth >= 1000 ? blackLogo : whiteLogo" alt="" class="mb-4 lg:w-full w-3/4 m-auto"/>
                    <div class="logo--title-wrapper" v-html="headerTitle" />
                    <a href="/contact" v-if="isContactPageAvailable"><button class="btn--main">Contact</button></a>
                    <a :href="presentation" v-if="presentation" download target="_blank"><button class="btn--main">Brochure</button></a>
                    <img v-if="homeSecondaryLogo" :src="homeSecondaryLogo" alt="" class="mt-8 w-1/2 m-auto"/>
                </div>
            </div>
        </section>
        <section class="subnav">
            <div class="subnav--wrapper">
                <router-link v-if="isCycloramaAvailable" :to="{ name: 'cyclorama', params: { locale: $store.state.config.locale } }" class="sub--nav_category">
                    <svg-vue icon="cyclorama" class="h-10 w-auto" />
                    <h4>Cyclorama</h4>
                </router-link>
                <router-link v-if="isOrbitalPageAvailable" :to="{ name: 'orbital-show', params: { locale: $store.state.config.locale } }" class="sub--nav_category">
                    <svg-vue icon="orbital" class="h-10 w-auto" />
                    <h4>Maquette<br/>Orbitale</h4>
                </router-link>
                <router-link v-if="isVirtualTourAvailable" :to="{ name: 'virtual-tour', params: { locale: $store.state.config.locale } }" class="sub--nav_category">
                    <svg-vue icon="tour" class="h-10 w-auto" />
                    <h4>Visite<br/>Virtuelles</h4>
                </router-link>
                <router-link class="sub--nav_category" :to="{ name: 'front-gallery', params: { locale: $store.state.config.locale } }">
                    <svg-vue icon="gallery" class="h-10 w-auto" />
                    <h4>Galerie</h4>
                </router-link>
                <router-link class="sub--nav_category" :to="{ name: 'video', params: { locale: $store.state.config.locale } }">
                    <svg-vue icon="video" class="h-7 w-auto" />
                    <h4>Vidéo</h4>
                </router-link>
            </div>
        </section>
        <section class="footer">
            <div class="footer--wraper">
                <h4>Proudly made by</h4>
                <img :src="'img/mysis-logo-footer.png'" alt="">
            </div>
        </section>
    </template>
</template>

<script>
    import Header from "../components/Header"
    import Loader from "../components/partials/loader"
    import { homeSecondaryLogoUrl } from "../composables/homeSecondaryLogo"
    import { isPageActive } from "../composables/pages"

    export default {
        data() {
            return {
                isMenuOpen: false,
                windowWidth: window.innerWidth,
            }
        },
        beforeMount() {
            // A switched-off orbital page stays reachable by its URL only: visitors must not land on it.
            if(!this.withMenu && this.isOrbitalPageAvailable) {
                this.$router.push({name: 'orbital-show'});
            }

            if(!this.$cookies.isKey('promptCookie') && this.withModal) {
                this.$store.dispatch('modals/open', 'prompt-modal')
            }

            window.addEventListener('resize', this.onResize);
        },
        computed: {
            isFrontOfficePending() {
                return this.$store.state.frontoffice.isPending;
            },
            domain() {
                return this.$store.state.frontoffice.domain;
            },
            isCycloramaAvailable() {
                return this.$store.state.frontoffice.isCycloramaAvailable;
            },
            isVirtualTourAvailable() {
                return this.$store.state.frontoffice.isVirtualTourAvailable;
            },
            isOrbitalPageAvailable() {
                return isPageActive(this.domain?.pages?.data, 'orbital');
            },
            isContactPageAvailable() {
                if(this.domain?.pages.data && this.domain?.pages.data.find( page => page.name === 'contact')) {
                    return !!Number(this.domain?.pages.data.find( page => page.name === 'contact').is_active)
                }

                return true;
            },
            whiteLogo() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'white-logo' ) && this.domain.settings.data.find( setting => setting.name === 'white-logo' ).image) {
                    return this.domain.settings.data.find( setting => setting.name === 'white-logo' ).image.url
                }

                return null
            },
            blackLogo() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'black-logo' ) && this.domain.settings.data.find( setting => setting.name === 'black-logo' ).image) {
                    return this.domain.settings.data.find( setting => setting.name === 'black-logo' ).image.url
                }

                return null
            },
            homeSecondaryLogo() {
                return homeSecondaryLogoUrl(this.domain?.settings.data, this.windowWidth)
            },
            splashImage() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'splash-image' ) && this.domain.settings.data.find( setting => setting.name === 'splash-image' ).image) {
                    return this.domain.settings.data.find( setting => setting.name === 'splash-image' ).image.url
                }

                return '/img/landing.jpg'
            },
            withMenu() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-menu' )) {
                    return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-menu' ).value)
                }

                return true
            },
            withModal() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-modal' )) {
                    return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-modal' ).value)
                }

                return false
            },
            headerTitle() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'header-title' )) {
                    return this.domain.settings.data.find( setting => setting.name === 'header-title' ).value
                }

                return 'Title';
            },
            presentation() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'presentation' ) && this.domain.settings.data.find( setting => setting.name === 'presentation' ).pdf) {
                    return this.domain.settings.data.find( setting => setting.name === 'presentation' ).pdf.url
                }

                return null
            },
        },
        methods: {
            handleOpenMenu() {
                this.isMenuOpen = true;
            },
            handleCloseMenu() {
                this.isMenuOpen = false;
            },
            handleOpenModal(modalName) {
                this.$store.dispatch('modals/open', modalName)
            },
            onResize() {
                this.windowWidth = window.innerWidth
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        components: {
            Header,
            Loader
        }
    }
</script>
